"use strict";

exports.__esModule = true;
exports.Button = Button;

var _react = _interopRequireDefault(require("react"));

var _utils = require("@bydesign-ui/utils");

var _hooks = require("@bydesign-ui/hooks");

var _config = require("@byte-design/config");

var _useWaveAnimation = require("../../hooks/useWaveAnimation");

var _LoadingIcon = _interopRequireDefault(require("./LoadingIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Button(props) {
  var children = props.children,
      className = props.className,
      _props$block = props.block,
      block = _props$block === void 0 ? false : _props$block,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style,
      _props$size = props.size,
      size = _props$size === void 0 ? 'md' : _props$size,
      _props$type = props.type,
      type = _props$type === void 0 ? 'default' : _props$type,
      _props$shape = props.shape,
      shape = _props$shape === void 0 ? 'angle' : _props$shape,
      _props$triangle = props.triangle,
      triangle = _props$triangle === void 0 ? false : _props$triangle,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      buttonDisabled = props.buttonDisabled,
      _props$ghost = props.ghost,
      ghost = _props$ghost === void 0 ? false : _props$ghost,
      _props$needGrouped = props.needGrouped,
      needGrouped = _props$needGrouped === void 0 ? true : _props$needGrouped,
      _props$htmlType = props.htmlType,
      htmlType = _props$htmlType === void 0 ? 'button' : _props$htmlType,
      _props$loading = props.loading,
      loading = _props$loading === void 0 ? false : _props$loading,
      _props$plain = props.plain,
      plain = _props$plain === void 0 ? type === 'default' ? true : false : _props$plain,
      onClick = props.onClick,
      extra = _objectWithoutPropertiesLoose(props, ["children", "className", "block", "style", "size", "type", "shape", "triangle", "disabled", "buttonDisabled", "ghost", "needGrouped", "htmlType", "loading", "plain", "onClick"]);

  var rtl = (0, _config.useDirection)() === 'rtl';
  var ref = (0, _useWaveAnimation.useWaveAnimation)({
    disabled: disabled
  });
  var groupedCls = (0, _config.usePrefixCls)('can-input-grouped');
  var loadingCls = (0, _config.usePrefixCls)('btn-loading');
  var cls = (0, _utils.classnames)((0, _config.usePrefixCls)('btn', {
    disabled: loading || disabled,
    size: size,
    type: type,
    shape: shape,
    block: block,
    triangle: triangle,
    ghost: ghost,
    rtl: rtl,
    plain: plain
  }), needGrouped ? groupedCls : '', loading ? loadingCls : '', className);
  var loadingIconCls = (0, _config.usePrefixCls)('btn-loading-icon');
  var clickHandle = (0, _hooks.useRefCallback)(function (event) {
    !loading && !disabled && (onClick === null || onClick === void 0 ? void 0 : onClick(event));
  });
  return _react.default.createElement("button", Object.assign({}, extra, {
    ref: ref,
    type: htmlType,
    className: cls,
    disabled: loading || (buttonDisabled !== null && buttonDisabled !== void 0 ? buttonDisabled : disabled),
    onClick: clickHandle,
    style: _extends({}, style, {
      display: style.display ? style.display : block ? 'block' : undefined
    })
  }), !!loading && _react.default.createElement("span", {
    className: loadingIconCls
  }, _react.default.createElement(_LoadingIcon.default, null)), children);
}